import { Literals } from "shared/types";

type Props = {
  email: string;
  copyTexts: Literals;
};

export const EmailNotificationInfo = (props: Props) => {
  const { email, copyTexts } = props;
  return (
    <div className="flex flex-row items-center justify-between rounded-xl bg-grey-200 px-4 py-3">
      <div className="flex flex-col justify-between">
        <p className="text-sm font-semibold">{copyTexts.notifiedByEmailText}</p>
        <p className="text-xs text-secondary">{email}</p>
      </div>
      <div id="bell">
        <i className="ti ti-bell-filled text-2xl text-grey-900	" />
      </div>
    </div>
  );
};
